<template>
<v-container :class="getPaddingSpace(1)">
    <v-layout row wrap :class="getPaddingSpace(2)">
        <v-flex>
            <FlightDetailsBox v-if="triptype!='M'" :flightDetails="flightDetails" :flightBagInfo="flightBagInfo"/>
            <FlightDetailsBoxMulticity v-if="triptype=='M'" :flightDetailsM="flightDetailsM" :flightBagInfo="flightBagInfo"/>
        </v-flex>
    </v-layout>
    <v-layout row wrap :class="getPaddingSpace(2)">
        <v-flex md8>
            <PassengerBox :viewModels="viewModels" @emPassengers="p=>updatedData.passengers=p" 
                @aPassengerIsContactPerson="isContact=>showContactInfoBox(isContact)" 
                :bookingPassengers="getPassengers()"
                :validationWatcher="validationWatcher"
                @emValidationPassed="v=>validations[0].validationPassed=v"
                />
            <ContactInfoBox @emContactInfo="c=>updatedData.contactInfo=c" v-if="showingContactInfoBox"
                :validationWatcher="validationWatcher"
                @emValidationPassed="v=>validations[1].validationPassed=v"
                />
            <PassengerPaymentBox 
              :sellingCurrency="statedData.sellingCurrency" @emSelectedPaymentType="pmt=>selectedPaymentType=pmt"/>
            <v-container>
                <v-layout row>
                    <v-flex md6>
                        <v-btn block color="primary" @click="goBackToFlightSearch()" class="mr-1">
                            <v-icon>navigate_before</v-icon>
                            <span>{{isMobile?"Back":"Search Again"}}</span>
                        </v-btn>
                    </v-flex>
                    <v-flex md6>
                        <v-btn :disabled="button1Disabled" block color="primary" :dark="button1Disabled==false" @click="checkValidations()" class="ml-1">
                            <span>{{isMobile?"Next":"Continue with Payment"}}</span>
                            <v-icon>navigate_next</v-icon>
                        </v-btn>          
                    </v-flex>
                </v-layout>      
            </v-container>

        </v-flex>
        <v-flex md4>
            <div :class="isMobile?'pl-3 mb-2':''">
                <FlightSummaryBox v-if="triptype!='M'" :flightDetails="flightDetails" :bagInfo="flightBagInfo"/>  
                <FlightSummaryBoxMulticityPax v-if="triptype=='M'" :flightDetails="flightDetails" :bagInfo="flightBagInfo"/>              
            </div>
            <BookingPriceBox :priceInfo="priceInfo" :processingFee="processingFee" :sellingCurrency="statedData.sellingCurrency" />
        </v-flex>
    </v-layout>
    <v-layout row wrap>
        <v-flex md12>
            <v-dialog persistent max-width="500" v-model="showAlertDialog">
                <v-card>
                    <v-card-title><b>Galileo Online - Alert</b></v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="text-xs-center">

                        <v-spacer></v-spacer>

                        <v-progress-circular md3 v-if="alertDialogText==':progress'"
                        :size="50"
                        color="primary"
                        indeterminate
                        ></v-progress-circular>

                        {{alertDialogText==":progress"? "":alertDialogText}}
                        
                        <v-spacer></v-spacer>  
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if=showAlertDialogOKButton md3 sm8 xs8 color="primary" flat @click="showAlertDialog = false">OK</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>                    
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>

</v-container>
</template>

<script>
/* eslint-disable */

import PassengerBox from './PassengerBox'
import ContactInfoBox from './ContactInfoBox'
import PassengerPaymentBox from './PassengerPaymentBox'
import FlightSummaryBox from '../CustomControls/FlightSummaryBox';
import FlightSummaryBoxMulticityPax from '../CustomControls/FlightSummaryBoxMulticityPax';
import BookingPriceBox from '../CustomControls/BookingPriceBox'
import Helper from '../helper';
import MockedFlightDetails from './mockedFlightDetails';
import FlightDetailsBox from './FlightDetailsBox';
import MockedPrices from './mockedPrices';
import Service from '../../services/passernger.service';
import InitDataService from '../../services/intData.service';
import BookingService from '../../services/booking.service';
import FlightDetailsBoxMulticity from './FlightDetailsBoxMulticity'

export default {
    data(){
        return {
            showingContactInfoBox:true,
            flightDetails:MockedFlightDetails.flightDetails,
            priceInfo:MockedPrices,
            statedData:{
                passengers:null,
                flights:null,
                sellingCurrency:null
            },
            updatedData:{
                passengers:{},
                contactInfo:{},
            },
            dataToPost:null,
            selectedPaymentType:null,
            viewModels:{
                airlineList:[],
                titleList:[],
                mealList:[],
                seatList:[],
            },
            validationWatcher:false,
            validations:[
                {name:"PassengerBox",validationPassed:false},
                {name:"ContactInfo",validationPassed:false},
            ],
            showAlertDialog:false,
            showAlertDialogOKButton:false,
            alertDialogText:"",
            button1Disabled:false,
            cityAirportNames:null,
            flightBagInfo:null,
            searchId:null,
            triptype:null,
            originM:[],
            destinationM:[],
            selectedFlightsNew:[],
            totSectors:1,
            flightDetailsM:[],
        }
    },
    computed:{
        showOkButtonOfAlertDialog(){
            return this.alertDialogText==":progress"? false:true;
        },
        isMobile(){
            let isMobile = Helper.display.isMobile(this.$vuetify.breakpoint.name);
            return isMobile;
        },  
        processingFee(){
            let val = 0;
            try {
                val = this.selectedPaymentType.processingFee;     
            } catch (error) {
                if (val==null) val = 0;  
            }

            return val;
        },      
    },
    created(){
        
        this.searchId = this.$route.params.sid;
        if (this.$store.state.passengerFfaresOfSelectedFlights.length == null){
            //this.goBackToFlightSearch();
        }


        if (this.$store.state.selectedFlights)
            this.statedData.flights = this.$store.state.selectedFlights;

        if (this.$store.state.passengerFfaresOfSelectedFlights[0])
            this.statedData.passengers = this.$store.state.passengerFfaresOfSelectedFlights;

        console.log('[PassengerInfo] store passengerFfaresOfSelectedFlights:', this.$store.state.passengerFfaresOfSelectedFlights);
        
        if (this.$store.state.triptype !=null){
            this.triptype=this.$store.state.triptype;
            this.originM=this.$store.state.originM;
            this.destinationM=this.$store.state.destinationM;
            this.selectedFlightsNew=this.$store.state.selectedFlightsNew;
            this.totSectors=this.$store.state.totSectors;            
        }

        if (this.$store.state.sellingCurrency !=null){
          this.statedData.sellingCurrency = this.$store.state.sellingCurrency;
        }

        if(this.triptype=="M"){
            this.buildFlightDetailBoxDataM();
        }
        this.buildFlightDetailBoxData();
        this.buildPriceBoxData();
        this.getPassengerViewModels();
        this.getPassengers();
        this.getPassengerViewModels();
        Helper.display.scrollToTop();
        //this.getCityAirportNames();
        if (this.statedData.passengers && this.statedData.passengers[0])
            this.getBagInfo(this.statedData.passengers[0].searchId);
    },
    components:{
        PassengerBox, 
        ContactInfoBox, 
        PassengerPaymentBox,
        FlightSummaryBox, 
        BookingPriceBox,
        FlightDetailsBox,
        FlightDetailsBoxMulticity,
        FlightSummaryBoxMulticityPax,
    },
    methods:{
        getBagInfo(sid){
            BookingService.getFlightBagInfo(sid).then (rslt=>{
                this.flightBagInfo = rslt.data;
            })
        },
        goBackToFlightSearch(){
            this.$router.push({name:'SharedLink',params:{sid:this.searchId}});
        },
        showAlertDialogWindow(message,show=true,okButton=false){
            this.showAlertDialog = show;
            this.alertDialogText = message;
            this.showAlertDialogOKButton = okButton            
        },
        checkValidations(){
            this.button1Disabled = true;
            this.validationWatcher = true;
            setTimeout(()=>{
                this.getContactInfoFromPassenger().then(rslt=>{
                    let data = {
                        passengers:this.updatedData.passengers,
                        contactInfo:this.updatedData.contactInfo,
                    }
                    this.buildDataForAjaxPost(data).then (rslt=>{
                        this.validationWatcher = false;

                        
                        

                        this.button1Disabled = false;
                        
                        if (
                            (this.validations[0].validationPassed == true && this.validations[1].validationPassed == true)||
                            (this.validations[0].validationPassed == true && this.showingContactInfoBox==false)
                        ){
                            this.showAlertDialogWindow(":progress",true,false);
                            this.createBooking();    
                            
                        }                        
                    });
                });
            },2000);
        },
        getPassengerViewModels(){
            Service.getPassengerViewModels().then(rslt=>{
                this.viewModels.airlineList = rslt.data.airlineList;
                this.viewModels.titleList = rslt.data.titleList;
                this.viewModels.mealList = rslt.data.mealList;
                this.viewModels.seatList = rslt.data.seatList;
            });
        },
        testRoutingToBookingInfo(){
            let data = "/GO/BookingInformation?sid=2019111900002082";
            let sid = Helper.queryString.getParameterByName("sid",data);
            if (sid!=""){
                //this.$state.commit('updateSidForShowingBookingInfo',sid);
                this.$router.push({name:'BookingInfo',params:{sid:sid}});
            }            
        },
        getContactInfoFromPassenger(){
            return new Promise(resolve=>{
                this.updatedData.passengers.every((p,index)=>{
                    if(p.isContactPerson){
                        this.updatedData.contactInfo.phoneNo = p.phoneNo;
                        this.updatedData.contactInfo.title = p.title;
                        this.updatedData.contactInfo.firstName = p.firstName;
                        this.updatedData.contactInfo.middleName = p.middleName;
                        this.updatedData.contactInfo.lastName = p.lastName;
                        this.updatedData.contactInfo.address = p.address;
                        this.updatedData.contactInfo.email = p.email;
                        //return false;
                        resolve(false);
                    }else {
                        //return true;
                        resolve(true);
                    }
                });
            });

        },
        createBooking(){
            //return;
            this.alertDialogText = ":progress";
            Service.savePassengerInfo(this.dataToPost).then(rslt=>{
                if (rslt.data==1){
                    if (this.selectedPaymentType!==null){
                        
                        Service.createBooking(this.selectedPaymentType.paymentType,this.selectedPaymentType.merchantType).then(rslt=>{
                            this.showAlertDialog = "";
                            this.showAlertDialog = false;
                            let rsp = rslt.data;
                            if (rsp=="P"){

                                this.showAlertDialogWindow("Payment Type not selected",true,true);

                            }else if (rsp=="0"){
  
                                this.showAlertDialogWindow("Booking creation process failed",true,true);

                            }else if (rsp.indexOf("formGMC") > -1){

                                this.goToBookingInformation(rsp);

                            }else if (rsp.indexOf("?sid") > -1){

                                this.goToBookingInformation(rsp);

                            }else if (rsp.indexOf("|wait") > -1){

                                this.goToBookingInformation(rsp);

                            }else {

                                this.alertDialogText= rsp;
                                this.showAlertDialog = true;    

                            }
                        });
                        
                    }else {                      
                        this.showAlertDialogWindow("",false,false);                
                        this.showAlertDialogWindow("Payment Type not selected.",true,true);                
                    }
                }else {                  
                    this.showAlertDialogWindow("",false,false);                
                    this.showAlertDialogWindow("Failed to save passengers' information.",true,true);
                }
            });
        },
        goToBookingInformation(rsp){
            let sid = Helper.queryString.getParameterByName("sid",rsp);
            if (sid!=""&&sid!=null){
                //this.$state.commit('updateSidForShowingBookingInfo',sid);
                this.$router.push({name:'BookingInfo',params:{sid:sid}});
            }            
        },
        getPassengers(){
            let passengersRawData = this.priceInfo;

            let passengers = [];
            let adtCount = !isNaN(passengersRawData.adultCount)? passengersRawData.adultCount:0;
            let chdCount = !isNaN(passengersRawData.childCount)? passengersRawData.childCount:
                !isNaN(passengersRawData.childrenCount)? passengersRawData.childrenCount:0;
            let infCount = !isNaN(passengersRawData.infantCount)? passengersRawData.infantCount:0;
            let stuCount = !isNaN(passengersRawData.studentCount)? passengersRawData.studentCount:0;
            let passengerNo =0;

            let passengerCountsByType = [adtCount,chdCount,infCount,stuCount];
            let passengerTypeCodes = ["ADT","CNN","INF","STU"];

            passengerCountsByType.forEach((c, index)=>{
                let ptc = passengerTypeCodes[index];
                let fareId = 0;

                if (this.statedData.passengers) {
                    this.statedData.passengers.forEach((p)=>{
                      if (p.ptc == ptc || (ptc == "CNN" && p.ptc == "CHD") || (ptc == "CHD" && p.ptc == "CNN")) {
                        fareId = p.fareId;
                        return false;
                      }
                    });
                }

                for (let i = 0;i< c;i++){
                    passengerNo++;
                    passengers.push (
                        {
                            passengerNo: passengerNo,
                            passengerNoByType: i+1,
                            passengerTypeCode:ptc,
                            passportRequired:false,
                            isContactPerson:false,
                            fareId: fareId,
                        }
                    );
                }              
            });

            console.log('[PassengerInfo] getPassengers -> result:', JSON.parse(JSON.stringify(passengers)));
            return passengers;

        },
        getPaddingSpace(option){
            let isMobile = Helper.display.isMobile(this.$vuetify.breakpoint.name);
            if (option===1){
                if (!isMobile){
                    return "";
                }else {
                    return "pl-0 pr-0";
                }
            }else if (option===2) {
                if (!isMobile){
                    return "pl-5 pr-5";
                }else {
                    return "";
                }
            }
        },
        showContactInfoBox(m){
            //alert(m);
            this.showingContactInfoBox=m!=true;
        },
        buildFlightDetailBoxData(){
            if (!this.statedData.flights) return;
            let data = {
                flightsOfDeparture:[],
                flightsOfReturn:[]
            };

            let flights = this.statedData.flights.FilteredDepartures;

            this.getCityAirportNames(this.statedData.flights).then(rslt=>{
                this.cityAirportNames = rslt.data;
                
                flights.forEach((f)=>{
                    let flt = this.buildFlightDetailBoxData_getNewFlightDataModel(f);
                    data.flightsOfDeparture.push(flt);   
                })

                if(this.statedData.flights.FilteredReturns){
                    flights = this.statedData.flights.FilteredReturns;

                    flights.forEach((f)=>{
                        let flt = this.buildFlightDetailBoxData_getNewFlightDataModel(f);
                        data.flightsOfReturn.push(flt);
                    })
                }
                this.flightDetails = data;
            });

            return data;
        },
        buildFlightDetailBoxDataM(){
            // let data = {
            //     flightsOfDeparture:[]
            // };
            let data = [];

            let flightlst = this.selectedFlightsNew;
            flightlst.forEach(flts => {
                let dt = {
                flightsOfDeparture:[]
                };
                let flights = flts.FilteredDepartures;

                flights.forEach((f)=>{
                    let flt = this.buildFlightDetailBoxData_getNewFlightDataModel(f);
                    dt.flightsOfDeparture.push(flt);   
                });
                data.push(dt);
            });
            this.flightDetailsM = data;
            return data;
        },
        getCityAirportNames(flights){
            return new Promise(resolve=>{
                let codes = [];
                flights.FilteredDepartures.forEach((val,index)=>{
                    let flight = val.Flight;
                    codes.push (flight.StartAirp);
                });

                if (flights.FilteredReturns) {
                    flights.FilteredReturns.forEach((val,index)=>{
                        let flight = val.Flight;
                        codes.push (flight.StartAirp);
                    });
                }

                InitDataService.getCityAirportNames(codes).then (rslt=>{
                    resolve(rslt);
                });
            })

        },
        buildPriceBoxData(){
            let prices = this.statedData.passengers;
            if (!prices) return;
            let data = {
                prices:{},
                taxes:{},
                qSurcharge:{},
            };
            
            //let keys = ["adult-5","child-0","infant-55","student-114"];
            let keys = {
              5:'adult', 0:'child', 55:'infant', 114:'student'
            };
            prices.forEach(p=>{

                if (p.Type!==1) {
                    let key = keys[p.Type];
                    data[key + 'Count'] = p.Count;
                    if (key === 'child') data['childrenCount'] = p.Count;
                }else{
                    data['childrenCount'] = p.Count;    
                }

                data.prices[keys[p.Type]] = p.Price;
                data.taxes[keys[p.Type]] = p.Tax;
                if (p.qSurcharge>0){
                    data.qSurcharge[keys[p.Type]] = p.QSercharge;
                }
            });

            console.log('[PassengerInfo] buildPriceBoxData -> priceInfo:', JSON.parse(JSON.stringify(data)));
            this.priceInfo = data;

        },
        buildFlightDetailBoxData_getNewFlightDataModel(rawFlightInfo){
            let rawFlight = rawFlightInfo.Flight;

            let apLnq = new this.$linq(this.cityAirportNames);

            let fnc = (code)=>{
                let cn = apLnq.where(a=>a.code==code).toArray()[0];
                return cn==null? "":cn.name;
            };

            let newFlight = {
                airline: rawFlight.AirV,
                flightNo: rawFlight.FltNum,
                stops: rawFlight.NumStops,
                origin: {
                    airport: {
                        code: rawFlight.StartAirp,
                        name: fnc(rawFlight.StartAirp),
                        terminal: rawFlight.StartTerminal
                    },
                    date: rawFlight.StartDt,
                    time: rawFlight.StartTm,
                },
                destination: {
                    airport: {
                        code: rawFlight.EndAirp,
                        name: fnc(rawFlight.EndAirp),
                        terminal: rawFlight.EndTerminal
                    },
                    date: rawFlight.EndDt,
                    time: rawFlight.EndTm,
                },
            }
            return newFlight;   
        },
        buildDataForAjaxPost(data){

            return new Promise(resolve=>{
                let enu = (v)=>{
                    return encodeURIComponent(v);
                };

                let keysets = [
                    ["paxSize"],
                    "selTitle,txtFName,txtMName,txtLName,hdfPtc,hdfFareId,selFFAirline,txtFFAirlineNo,selMeal,selDOBDay,selDOBMonth,selDOBYear,selSeat".split(","),
                    "conPhone,conTitle,conFirstName,conMidName,conLastName,conAddr,conCountry,conEmail".split(",")
                ];

                let psngrs = data.passengers;
                let ctcinf = data.contactInfo

                if (this.showingContactInfoBox==true){
                    //ctcinf.
                }

                let valuesets = [
                    [enu(psngrs.length)],
                    [],
                    [
                        enu(ctcinf.phoneNo.toUpperCase()), enu("-"),enu(ctcinf.firstName.toUpperCase()), enu(ctcinf.middleName.toUpperCase()), enu(ctcinf.lastName.toUpperCase()),
                        enu(ctcinf.address.toUpperCase()), enu("-"), enu(ctcinf.email.toUpperCase())
                    ]
                ];

                for(let i=0;i<psngrs.length;i++){
                    valuesets[1][i] = [
                        enu(psngrs[i].title),  enu(psngrs[i].firstName.toUpperCase()), enu(psngrs[i].middleName.toUpperCase()), enu(psngrs[i].lastName.toUpperCase()), enu(psngrs[i].passengerTypeCode),
                        enu(psngrs[i].fareId), enu(psngrs[i].fqFlyerProgramAirline), enu(psngrs[i].fqFlyerNo.toUpperCase()), enu(psngrs[i].meal), 
                        enu(psngrs[i].dobDay), enu(psngrs[i].dobMonth), enu(psngrs[i].dobYear), enu(psngrs[i].seatPreference)
                    ]
                }

                let kVals = [
                    [],[],[]
                ];

                for (let i =0;i<keysets.length;i++){
                    if (i==1){
                        valuesets[i].forEach(p=>{
                            let indx = kVals[i].length; 
                            kVals[i][indx] = [];                        
                            for (let j=0;j<p.length;j++){
                                kVals[i][indx][j]={key:keysets[i][j]+"_"+indx,value:valuesets[i][indx][j]}
                            }
                        });
                    }else{
                        for (let j =0;j<keysets[i].length;j++){
                            kVals[i][j] = {key:keysets[i][j], value:valuesets[i][j]};
                        }
                    }
                }
                
                let dataToPost = "";
                for(let i = 0;i<kVals.length;i++){
                    if (i==1){                
                        for(let j=0;j<kVals[i].length;j++){
                                for(let k=0;k<kVals[i][j].length;k++){
                                    dataToPost += (dataToPost!=""? "&":"") +kVals[i][j][k].key + "=" + kVals[i][j][k].value;
                                }
                        }


                    }else{
                        for(let j=0;j<kVals[i].length;j++){
                            dataToPost += (dataToPost!=""? "&":"") +kVals[i][j].key+ "=" + kVals[i][j].value; 
                        }                    
                    }
                }
                
                this.dataToPost = dataToPost;
                resolve(true);
            });


        },        
    }
}
</script>

<style>

</style>